
import {createAsyncThunk} from '@reduxjs/toolkit'
import {getSupplementalPay} from 'sr/utils/api/masterData/supplementalpay/getSupplementalPay'
export const fetchsupplementalpay = createAsyncThunk(
  'getSupplementalPay',
  async () => {
    const response = await getSupplementalPay()
    return response?.data
  }
)


